import React, { useState, useEffect } from "react";
import "./toast.scss";
import x from "../../assets/svgs/x-green.svg";
import PropTypes from "prop-types";
import Button from "../inputs/button";

function Toast({ status, message, title, callback, autoHide, action }) {
	const [toast, setToast] = useState(true);

	useEffect(() => {
		if (status != "Invalid") {
			const timer = setTimeout(() => {
				if (autoHide && toast) {
					setToast(false);
					callback ? callback() : "";
				}
			}, 10000);
			// A toast replaced or closed before its 10 s must not close whatever shows next.
			return () => clearTimeout(timer);
		}
	}, [toast]);

	return (
		<>
			{toast && (
				<div className="toastContainer">
					<div className="toast--inner">
						<div className="toast--inner--head">
							<div>
								<span className={"dot--" + status}> </span> {!title ? status : title}
							</div>
							<img
								src={x}
								className="close"
								alt="close"
								role={"button"}
								onClick={() => [setToast(false), callback ? callback() : ""]}
							/>
						</div>
						<div className="toast--inner--body">
							<p className="p3 no-margin message">{message}</p>
							{action ? <div className="toast--inner--action">{action}</div> : null}
						</div>
					</div>
				</div>
			)}
		</>
	);
}

Toast.propTypes = {
	title: PropTypes.string.isRequired,
	status: PropTypes.oneOf(["Success", "Invalid", "Info"]).isRequired,
	message: PropTypes.string.isRequired,
	callback: PropTypes.func,
	autoHide: PropTypes.bool,
	// Optional: a link or button under the message.
	action: PropTypes.node,
};

export default Toast;
